import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Offcanvas, Nav, Accordion } from 'react-bootstrap'
import clsx from 'clsx'
import { getMenuItems, clearMenuCache } from '../../../../helpers/Menu'
import IconifyIcon from '../../../../components/wrapper/IconifyIcon'

const MobileMenu = ({ show, onHide }) => {
    const [menuItems, setMenuItems] = useState([])
    const location = useLocation()

    const loadMenuItems = async () => {
        try {
            const items = await getMenuItems()
            setMenuItems(items || [])
        } catch (error) {
            console.error('Error loading mobile menu items:', error)
            setMenuItems([])
        }
    }

    useEffect(() => {
        loadMenuItems()

        const updateMenu = () => {
            clearMenuCache() // Clear cache when filters are updated
            loadMenuItems()
        }

        window.addEventListener('gameFiltersUpdated', updateMenu)
        window.addEventListener('languageChanged', updateMenu)

        return () => {
            window.removeEventListener('gameFiltersUpdated', updateMenu)
            window.removeEventListener('languageChanged', updateMenu)
        }
    }, [])

    return (
        <Offcanvas show={show} onHide={onHide} placement="start" style={{ backgroundColor: '#121212', borderRight: '1px solid #333', maxWidth: '85%' }}>
            <Offcanvas.Header closeButton closeVariant="white">
                <Offcanvas.Title className="text-white font-header">FILTERMARKET</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-0">
                <Nav className="flex-column p-3">
                    {menuItems.map((item, idx) => {
                        if (item.isTitle) {
                            return <div key={idx} className="text-muted small fw-bold mt-3 mb-2 px-2 text-uppercase letter-spacing-2">{item.label}</div>
                        }

                        if (item.children) {
                            return (
                                <Accordion key={idx} className="mobile-menu-accordion mb-1">
                                    <Accordion.Item eventKey={String(idx)} style={{ background: 'transparent', border: 'none' }}>
                                        <Accordion.Header className="mobile-accordion-header">
                                            <div className="d-flex align-items-center w-100 text-white">
                                                {item.icon && <IconifyIcon icon={item.icon} className="me-2 text-neon-green" />}
                                                {item.label}
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body className="p-0 bg-transparent">
                                            <div className="d-flex flex-column ps-3 border-start border-secondary ms-2 mt-1">
                                                {item.children.map((child, cIdx) => (
                                                    <Nav.Link
                                                        key={cIdx}
                                                        as={Link}
                                                        to={child.url || '#'}
                                                        onClick={onHide}
                                                        className={clsx("text-white-50 py-2", location.pathname === child.url && "text-neon-green fw-bold")}
                                                    >
                                                        {child.label}
                                                    </Nav.Link>
                                                ))}
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            )
                        }

                        return (
                            <Nav.Link
                                key={idx}
                                as={Link}
                                to={item.url}
                                onClick={onHide}
                                className={clsx("text-white py-2 d-flex align-items-center", location.pathname === item.url && "text-neon-green fw-bold")}
                            >
                                {item.icon && <IconifyIcon icon={item.icon} className="me-2" />}
                                {item.label}
                            </Nav.Link>
                        )
                    })}
                </Nav>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default MobileMenu
